export interface Input extends Marko.SVG.SVG {}

<svg ...input width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
        d="M6.142 2.20475L17.342 8.86964C18.2193 9.39172 18.2193 10.6083 17.342 11.1304L6.142 17.7953C5.20953 18.3501 4 17.7119 4 16.6649V3.33511C4 2.28814 5.20953 1.64985 6.142 2.20475Z"
        fill="currentCOlor"/>
</svg>
